export const STAR_EXPERIENCE_RECEIVED = 10

export const SYNC_USER_INFO_ERROR = 'SyncService: user info is not set'
